import React from "react";
import "../styles/layout-component.css";

const LayoutComponent = ({
  layout,
  templateData,
  onButtonClick,
  secondaryImage,
}) => {
  const renderLayout1 = () => (
    <div
      className="row d-flex align-items-center p-3 outer-container"
      id="outer-container"
    >
      <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 col-12"></div>
      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 d-flex justify-content-start">
        <img
          style={{ height: "300px" }}
          id="mainimage"
          className="img-fluid"
          src={
            templateData != null
              ? templateData.secondaryImageUrl
              : secondaryImage
          }
          alt=""
        />
      </div>
      <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 col-12"></div>
      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <div className="row p-3 d-flex align-items-center">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5 pt-5">
            <p
              className="heading mobileScreenPadding"
              style={{ color: templateData.textColor }}
            >
              {templateData.heading || "Welcome to Swageazy Gift Redemption!"}
            </p>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
            <p
              className="below-heading-content"
              style={{ color: templateData.textColor }}
            >
              {templateData.content || "Click below to redeem your gift :)"}
            </p>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5 ">
            <button
              onClick={onButtonClick}
              style={{ backgroundColor: templateData.buttonColor }}
              className="p-3 redeem-swag-btn"
            >
              <span style={{ color: templateData.ctaColor }}>
                {templateData.buttonText || "Claim Swag"}
              </span>
            </button>
          </div>
        </div>
      </div>
      {/* <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-5 mobileViewButton">
        <button
          onClick={onButtonClick}
          style={{ backgroundColor: templateData.buttonColor }}
          className="p-3 redeem-swag-btn"
        >
          Redeem Your Gift
        </button>
      </div> */}
    </div>
  );

  const renderLayout2 = () => (
    <div
      className="row d-flex align-items-center p-3 outer-container"
      id="outer-container"
    >
      <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 col-12"></div>
      {/* <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <div className="row p-3 d-flex align-items-center">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5 pt-5">
            <p className="heading mobileScreenPadding">
              {templateData.heading || "Welcome to Swageazy Gift Redemption!"}
            </p>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
            <p className="below-heading-content" style={{ color: templateData.textColor }}>
              {templateData.content || "Click below to redeem your gift :)"}
            </p>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5 desktopViewButton">
            <button
              onClick={onButtonClick}
              style={{ backgroundColor: templateData.buttonColor }}
              className="p-3 redeem-swag-btn"
            >
              <span style={{ color: templateData.ctaColor }}>
                {templateData.buttonText || "Claim Swag"}
              </span>
            </button>
          </div>
        </div>
      </div> */}
      <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 col-12"></div>
      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 layout2-image">
        <img
          style={{ height: "300px" }}
          id="mainimage"
          className="img-fluid"
          src={
            templateData != null
              ? templateData.secondaryImageUrl
              : secondaryImage
          }
          alt=""
        />
      </div>
      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 layout2-text">
        <div className="row p-3 d-flex align-items-center">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5 pt-5">
            <p
              className="heading mobileScreenPadding"
              style={{ color: templateData.textColor }}
            >
              {templateData.heading || "Welcome to Swageazy Gift Redemption!"}
            </p>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
            <p
              className="below-heading-content"
              style={{ color: templateData.textColor }}
            >
              {templateData.content || "Click below to redeem your gift :)"}
            </p>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5">
            <button
              onClick={onButtonClick}
              style={{ backgroundColor: templateData.buttonColor }}
              className="p-3 redeem-swag-btn"
            >
              <span style={{ color: templateData.ctaColor }}>
                {templateData.buttonText || "Claim Swag"}
              </span>
            </button>
          </div>
        </div>
      </div>
      {/* <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-5  mobileViewButton2">
        <button
          onClick={onButtonClick}
          style={{ backgroundColor: templateData.buttonColor }}
          className="p-3 redeem-swag-btn"
        >
          Redeem Your Gift
        </button>
      </div> */}
    </div>
  );

  const renderLayout3 = () => (
    <div
      className="row d-flex align-items-center p-3 outer-container"
      id="outer-container"
    >
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center mb-4">
        <img
          style={{ height: "300px" }}
          id="mainimage"
          className="img-fluid layout3Image"
          src={
            templateData != null
              ? templateData.secondaryImageUrl
              : secondaryImage
          }
          alt=""
        />
      </div>
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-8 col-md-10 col-sm-12 col-12">
            <div className="mt-3 mb-3">
              <p
                className="heading mobileScreenPadding"
                style={{ color: templateData.textColor }}
              >
                {templateData.heading || "Welcome to Swageazy Gift Redemption!"}
              </p>
            </div>
            <div className="mt-3 mb-4">
              <p
                className="below-heading-content"
                style={{ color: templateData.textColor }}
              >
                {templateData.content || "Click below to redeem your gift :)"}
              </p>
            </div>
            <div className="mt-4 mb-4 desktopViewButton">
              {/* <button
                onClick={onButtonClick}
                style={{ backgroundColor: templateData.buttonColor }}
                className="p-3 redeem-swag-btn"
              >
                Redeem Your Gift
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12  d-flex justify-content-center  mobileViewButton">
        <button
          onClick={onButtonClick}
          style={{ backgroundColor: templateData.buttonColor }}
          className="p-3 redeem-swag-btn"
        >
          <span style={{ color: templateData.ctaColor }}>
            {templateData.buttonText || "Claim Swag"}
          </span>
        </button>
      </div>
    </div>
  );

  const renderDefaultLayout = () => (
    <div
      className="row d-flex align-items-center p-3 outer-container"
      id="outer-container"
    >
      <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 col-12"></div>
      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <div className="row p-3 d-flex align-items-center">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5 pt-5">
            <p
              className="heading mobileScreenPadding"
              style={{ color: templateData.textColor }}
            >
              {templateData.heading || "Welcome to Swageazy Gift Redemption!"}
            </p>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
            <p
              className="below-heading-content"
              style={{ color: templateData.textColor }}
            >
              {templateData.content || "Click below to redeem your gift :)"}
            </p>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5 desktopViewButton">
            <button
              onClick={onButtonClick}
              style={{ backgroundColor: templateData.buttonColor }}
              className="p-3 redeem-swag-btn"
            >
              <span style={{ color: templateData.ctaColor }}>
                {templateData.buttonText || "Claim Swag"}
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 col-12"></div>
      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 d-flex justify-content-center">
        <img
          style={{ height: "300px" }}
          id="mainimage"
          className="img-fluid"
          src={
            templateData != null
              ? templateData.secondaryImageUrl
              : secondaryImage
          }
          alt=""
        />
      </div>
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-5 mobileViewButton">
        <button
          onClick={onButtonClick}
          style={{ backgroundColor: templateData.buttonColor }}
          className="p-3 redeem-swag-btn"
        >
          <span style={{ color: templateData.ctaColor }}>
            {templateData.buttonText || "Claim Swag"}
          </span>
        </button>
      </div>
    </div>
  );

  // Render the appropriate layout based on the layout number
  switch (layout) {
    case 1:
      return renderLayout1();
    case 2:
      return renderLayout2();
    case 3:
      return renderLayout3();
    default:
      return renderDefaultLayout();
  }
};

export default LayoutComponent;
